import shop from '~/lib/api/shop';
import { getUrl } from '~/services/shop/utils';

type Args = {
    customerId: string | null;
    userId: string | null;
    token: string | null;
};

export default function deleteUser({ userId, customerId, token }: Args) {
    const url = getUrl(`/customers/${customerId}`);

    if (userId) {
        url.searchParams.append('userId', userId);
    }

    return shop
        .delete(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .json<string>();
}
